import React from "react";
import axios from "axios"
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
//import TextField from "@mui/material/TextField";
//import Button from "@mui/material/Button";
//import Alert from "@mui/material/Alert";
//import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
//import IconButton from "@mui/material/IconButton";
//import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
//import { YoutubeSearchedForOutlined } from "@mui/icons-material";


//export default 
function Pedidos() {

    const [pedidos, setPedidos] = useState([]);
    const [paquetes, setPaquetes] = useState([]);
    const loggedIn = sessionStorage.getItem("loggedIn");
    const userData = JSON.parse(sessionStorage.getItem("userData"));
    //const clienteID = sessionStorage.getItem("email");
    const clienteid = userData?.clienteid;
    const navigate = useNavigate();
    //sessionStorage.setItem('clienteid', JSON.stringify(clienteid));


    useEffect(() => {
        if (!loggedIn) {
            navigate("/login");
        }else{
            getPedidos();
        }
    }, []);


   function getPedidos() {
       
        axios.get('https://boxerlogistica.com/api/pedidos.php', {
            params: {
                clienteid: 'raulzar@yahooo.com.mx'
            }
          }).then(function(response) {
            console.log(response.data);
            setPedidos(response.data);
        });
        
     
    }

    const deletePedidos = (id) => {
        axios.delete('https://boxerlogistica.com/api/pedidos.php').then(function(response){
            console.log(response.data);
            getPedidos();
        });
    }

    const getPaquetes = (id) => {
        axios
            .post("https://boxerlogistica.com/api/paquetes.php", {
                envio: id
            })
            .then((response) => {
                console.log(response);
                //setApiResponse(response.data.message);
                setPaquetes(response.data);
            })
            .catch((error) => {
                console.error(error);
                //setApiResponse(error.response.data.message);
            });
    }
    
    return (
        <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "5%",
      }}
    >
        <Container maxWidth="sm">
        <div><Typography
        style={{ marginBottom: "20px" }}
        variant="h2"
        component="h2"
      >
            Mis Envios
            </Typography>
            <table>
                    {pedidos.map((pedido, key) =>
                        <tr key={key}>
                            <td>
                            <table>
                                <tr>
                                    <td>
                                        <div class="container">
                                            Pedido # {pedido.id}  {pedido.status}<br />De:
                                            <div class="row">
                                                <div class="col-25">
                                                <label for="nombreOrigen">Nombre Completo/Empresa</label>
                                                </div>
                                                <div class="col-75">
                                                    {pedido.nombreOrigen}
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-25">
                                                <label for="contactoOrigen">Nombre Contacto</label>
                                                </div>
                                                <div class="col-75">
                                                    {pedido.contactoOrigen}
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-25">
                                                <label for="direccionOrigen">Dirección</label>
                                                </div>
                                                <div class="col-75">
                                                    {pedido.direccionOrigen}
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-25">
                                                <label for="emailOrigen">Email</label>
                                                </div>
                                                <div class="col-75">
                                                    {pedido.emailOrigen}
                                                </div>
                                            </div> 
                                            <div class="row">
                                                <div class="col-25">
                                                <label for="telefonoOrigen">Telefono</label>
                                                </div>
                                                <div class="col-75">
                                                    {pedido.telefonoOrigen}
                                                </div>
                                            </div> 
                                            </div>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td>    
                                        <div class="container">
                                            Para:
                                            <div class="row">
                                                <div class="col-25">
                                                <label for="nombreDestino">Nombre Completo/Empresa</label>
                                                </div>
                                                <div class="col-75">
                                                    {pedido.nombreDestino}
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-25">
                                                <label for="contactoDestino">Contacto</label>
                                                </div>
                                                <div class="col-75">
                                                    {pedido.contactoDestino}
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-25">
                                                <label for="direccionDestino">Dirección</label>
                                                </div>
                                                <div class="col-75">
                                                    {pedido.direccionDestino}
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-25">
                                                <label for="emailDestino">Email</label>
                                                </div>
                                                <div class="col-75">
                                                    {pedido.emailDestino}
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-25">
                                                <label for="telefonoDestino">Telefono</label>
                                                </div>
                                                <div class="col-75">
                                                    {pedido.telefonoDestino}
                                                </div>
                                            </div>
                                            </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="4">
                                    <div class="container">
                                        <table>
                                    <tr>
                                    <td>

                                        
                                            Paquete:
                                            <div class="row">
                                                <div class="col-25">
                                                <label for="altura">Altura</label>
                                                </div>
                                                <div class="col-75">
                                                {pedido.altura} 
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-25">
                                                <label for="ancho">Ancho</label>
                                                </div>
                                                <div class="col-75">
                                                {pedido.ancho}
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-25">
                                                <label for="largo">Largo</label>
                                                </div>
                                                <div class="col-75">
                                                {pedido.largo}
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-25">
                                                <label for="peso">Peso</label>
                                                </div>
                                                <div class="col-75">
                                                {pedido.peso}
                                                </div>
                                            </div>
                                        
                                        </td>
                                        </tr>
                                         
                                        </table>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="4">
                                    <hr></hr>
                                    </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    )}
            </table>
        </div>
        </Container>
        </Box>
    )
}
/*
`nombreOrigen` varchar(300) NOT NULL,
  `contactoOrigen` varchar(300) NOT NULL,
  `direccionOrigen` varchar(500) NOT NULL,
  `latOrigen` DOUBLE NULL,
  `lngOrigen` DOUBLE NULL,
  `emailOrigen` varchar(100) NOT NULL,
  `telefonoOrigen` varchar(100) NOT NULL,
  `nombreDestino` varchar(300) NOT NULL,
  `contactoDestino` varchar(300) NOT NULL,
  `direccionDestino` varchar(500) NOT NULL,
  `latDestino` DOUBLE NULL,
  `lngDestino` DOUBLE NULL,
  `emailDestino` varchar(100) NOT NULL,
  `telefonoDestino` varchar(100) NOT NULL,
  `cp` varchar(255) NOT NULL,
  `status_Desc` varchar(255) NOT NULL,
  `creation_time` timestamp NOT NULL DEFAULT current_timestamp()
  */

export default Pedidos;